<div class="w-auto">
  <cds-select [(ngModel)]="time"
              [compareWith]="compare"
              [disabled]="disabled()">
    @for (t of times; track t) {
      <cds-option [value]="t">{{ t }}</cds-option>
    }
  </cds-select>
</div>
